import * as React from 'react';
import style from './MembershipTitle.module.scss';
import { Typography } from 'antd';

interface MembershipTitleProps {
    title: string;
    intro?: string;
    description?: string;
}

const MembershipTitle: React.FC<MembershipTitleProps> = ({
    title,
    intro,
    description
}) => {
    return (
        <div className={style.container}>
            <Typography.Title level={2} className={style.appTitle}>
                {title}
            </Typography.Title>
            <div className={style.textContainer}>
                {!!intro && (
                    <Typography.Text className={style.appUserName}>
                        {intro}
                    </Typography.Text>
                )}
                {!!description && (
                    <Typography.Text className={style.dsc}>
                        {description}
                    </Typography.Text>
                )}
            </div>
        </div>
    );
};

export default MembershipTitle;
